<h2 mat-dialog-title class="d-flex align-items-center gap-2">
  <mat-icon>switch_account</mat-icon>
  Ouvrir une session au nom d'un utilisateur
</h2>

<mat-dialog-content>
  <div *ngIf="resolving" class="d-flex align-items-center gap-3 p-3">
    <mat-spinner diameter="24"></mat-spinner>
    <span>Recherche du compte administrateur de l'agence…</span>
  </div>

  <ng-container *ngIf="!resolving">
    <div *ngIf="candidates.length > 1" class="mb-3">
      <p class="mb-2" *ngIf="fallbackToAnyMember">
        Aucun compte <strong>administrateur</strong> actif pour {{ agencyName }}. Choisissez un
        autre membre de l'agence :
      </p>
      <p class="mb-2" *ngIf="!fallbackToAnyMember">
        Plusieurs administrateurs pour {{ agencyName }}. Choisissez le compte à utiliser :
      </p>
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>Utilisateur</mat-label>
        <mat-select [(ngModel)]="selected" data-testid="impersonation-user-select">
          <mat-option *ngFor="let candidate of candidates" [value]="candidate">
            {{ candidate.firstName }} {{ candidate.lastName }} — {{ candidate.email }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="selected" class="warning-box p-3">
      <p class="mb-2">
        Vous allez naviguer sur le site de vente en tant que
        <strong>{{ targetName }}</strong>
        <span *ngIf="selected.email"> ({{ selected.email }})</span
        ><span *ngIf="agencyName"> — {{ agencyName }}</span>.
      </p>
      <p class="mb-2">
        Toutes les actions effectuées lui seront <strong>attribuées</strong>. Votre identité reste
        tracée en parallèle côté serveur.
      </p>
      <p class="mb-0">
        La session s'ouvre dans un nouvel onglet et dure <strong>15 minutes</strong>, sans
        prolongation possible : passé ce délai, il faudra la rouvrir depuis cet écran. Pour en
        sortir avant, déconnectez-vous.
      </p>
    </div>

    <p *ngIf="errorMessage" class="text-danger mt-3 mb-0" data-testid="impersonation-error">
      {{ errorMessage }}
    </p>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions class="justify-content-end gap-2">
  <button mat-raised-button class="btn-pulpo" (click)="dialogRef.close(false)"
    data-testid="impersonation-cancel">
    <mat-icon>close</mat-icon>
    Annuler
  </button>
  <button mat-raised-button class="btn-pulpo-red" (click)="confirm()"
    [disabled]="!selected || resolving || opening" data-testid="impersonation-confirm">
    <mat-icon *ngIf="!opening">switch_account</mat-icon>
    <mat-spinner *ngIf="opening" diameter="18" class="d-inline-block me-2"></mat-spinner>
    Ouvrir la session
  </button>
</mat-dialog-actions>
